import { getEnvParam } from 'env'

const getPersonaDomain = (): string | null => {
  const userInternalEmail = getEnvParam('userInternalEmail') as string | null
  const userEmail = getEnvParam('userEmail') as string | null
  if (userInternalEmail && userInternalEmail !== userEmail) {
    return userInternalEmail.split('@')[1]
  }
  return null
}

export const isPersonaSession = (): boolean => getPersonaDomain() !== null

export const isPersonaEmail = (email: string): boolean => {
  const personaDomain = getPersonaDomain()
  if (!personaDomain) return false
  return email.endsWith(`@${personaDomain}`)
}

/**
 * 표시용 이메일을 페르소나 도메인 주소로 인코딩한다.
 * 예: friend@other.com + persona.dom -> friend_at_other.com@persona.dom
 */
export const getPersonaEmailFromDisplayEmail = (email: string, personaDomain: string): string => {
  return `${email.replace('@', '_at_')}@${personaDomain}`
}

export const getDisplayEmailFromPersonaEmail = (email: string): string => {
  const localPart = email.split('@')[0]
  const lastAtIndex = localPart.lastIndexOf('_at_')
  if (lastAtIndex === -1) return localPart
  return `${localPart.slice(0, lastAtIndex)}@${localPart.slice(lastAtIndex + '_at_'.length)}`
}
